import { OnChanges, SimpleChanges } from '@angular/core';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ComponentName, SelectionChangeType, EventMappingType, TimeFilter } from 'src/app/models/enums';
import { IEvenResultsAndScoreGroups } from 'src/app/models/results/evenResultsAndScoreGroups.interface';
import { IEventResult } from 'src/app/models/results/eventResult.interface';
import { ISportRegionCompetitionSelection } from 'src/app/models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { EventsService } from 'src/app/services/events.service';
import { LoaderService } from 'src/app/services/loader.service';
import { SportsService } from 'src/app/services/sports.service';

@Component({
  selector: 'app-results-sports-selection-container',
  templateUrl: './results-sports-selection-container.component.html',
  styleUrls: ['./results-sports-selection-container.component.less']
})
export class ResultsSportsSelectionContainerComponent implements OnInit, OnChanges, OnDestroy {

  public evenResultsAndScoreGroups: IEvenResultsAndScoreGroups = {
    eventResults: [],
    scoreGroups: [],
  };

  public filteredEventResults: IEventResult[] = [];

  private timeFilterChanged = false;
  private sportRegionCompetitionSelection: ISportRegionCompetitionSelection = {
    sport: null,
    region: null,
    competition: null,
  };
  private subscription: Subscription = new Subscription();

  constructor(
    private sportsService: SportsService,
    private eventsService: EventsService,
    private loaderService: LoaderService) {
    this.subscription.add(sportsService.srcSelectionChanged$.subscribe((x) => {
      if (!this.sportsService.sportRegionCompetitionSelection) {
        return;
      }

      const onlyFilter = !this.timeFilterChanged &&
        this.sportRegionCompetitionSelection &&
        this.sportRegionCompetitionSelection.sport &&
        this.sportRegionCompetitionSelection.sport.id === this.sportsService.sportRegionCompetitionSelection.sport.id &&
        this.sportRegionCompetitionSelection.region &&
        this.sportRegionCompetitionSelection.region.id === this.sportsService.sportRegionCompetitionSelection.region.id;

      this.sportRegionCompetitionSelection.sport = this.sportsService.sportRegionCompetitionSelection.sport;
      this.sportRegionCompetitionSelection.region = this.sportsService.sportRegionCompetitionSelection.region;
      this.sportRegionCompetitionSelection.competition = this.sportsService.sportRegionCompetitionSelection.competition;
      this.getEventResultsAndScoreGroups(onlyFilter);

      if (x.callFrom === ComponentName.ResultsSportsSelectionContainerComponent) {
        return;
      }
    }));

    // this.subscription.add(sportsService.timeFilterChanged$.subscribe(() => this.getEventResultsAndScoreGroups(false)));
  }

  @Input()
  timeFilterValue: TimeFilter;

  ngOnInit(): void {
  }

  ngOnChanges() {
    if (this.timeFilterValue === TimeFilter.None) {
      this.clearResults();
    }
    this.timeFilterChanged = true;
  }

  private clearResults() {
    this.evenResultsAndScoreGroups = {
      eventResults: [],
      scoreGroups: [],
    };
    this.filteredEventResults = [];
  }

  private getEventResultsAndScoreGroups(onlyFilter: boolean) {
    if (this.timeFilterValue === TimeFilter.None) {
      return;
    }
    if (!this.sportRegionCompetitionSelection || !this.sportRegionCompetitionSelection.sport) {
      this.clearResults();
      return;
    }
    this.timeFilterChanged = false;
    if (!onlyFilter) {
      this.loaderService.showHideLoader(true);
      this.eventsService.getFinishedEventsResultsForSelection(
        this.timeFilterValue,
        this.sportRegionCompetitionSelection.sport,
        this.sportRegionCompetitionSelection.region,
        // always get for whole region because cmp cant be selected before region is loaded
        null).subscribe((res) => {
          this.evenResultsAndScoreGroups = res;
          this.filterBySelection();
          this.loaderService.showHideLoader(false);
        });
    } else {
      this.filterBySelection();
    }
  }

  filterBySelection() {
    if (this.sportRegionCompetitionSelection.competition) {
      this.filteredEventResults = this.evenResultsAndScoreGroups.eventResults.filter(res => res.competitionId === this.sportRegionCompetitionSelection.competition.id);
    } else {
      this.filteredEventResults = this.evenResultsAndScoreGroups.eventResults.filter(res => res.regionId === this.sportRegionCompetitionSelection.region.id);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
